// =============================================================================
// FacilityClassifier — pure lookup port of Data/EconomyDataTypes.cs
// FacilityClassifier static class. No UnityEngine.Color — web drop.
// =============================================================================

import type { FacilityCategory, FacilityType } from "@gdg/shared";

/** Coal, Oil, Biomass, OffshoreDrilling — dirty, passive pollution every turn. */
export function isFossil(facility: FacilityType): boolean {
  return (
    facility === "Coal" ||
    facility === "Oil" ||
    facility === "Biomass" ||
    facility === "OffshoreDrilling"
  );
}

/** Wind, Solar, FloatingSolar, Tidal, Hydro — zero passive pollution. */
export function isRenewable(facility: FacilityType): boolean {
  return (
    facility === "Wind" ||
    facility === "Solar" ||
    facility === "FloatingSolar" ||
    facility === "Tidal" ||
    facility === "Hydro"
  );
}

/** All renewable + Geothermal + Nuclear (low-carbon). */
export function isClean(facility: FacilityType): boolean {
  return isRenewable(facility) || facility === "Geothermal" || facility === "Nuclear";
}

/** Picker accent-strip categories (5 buckets). Drives card color. */
export function getCategory(ft: FacilityType): FacilityCategory {
  switch (ft) {
    case "Coal":
    case "Oil":
    case "Biomass":
    case "OffshoreDrilling":
      return "Fossil";
    case "Wind":
    case "Solar":
    case "FloatingSolar":
    case "Tidal":
    case "Hydro":
      return "Renewable";
    case "Nuclear":
      return "Nuclear";
    case "Geothermal":
      return "Geothermal";
    case "WasteToEnergy":
      return "Waste";
    default: {
      // exhaustive check — TypeScript narrows ft to `never` here
      const _exhaustive: never = ft;
      throw new Error(`[FacilityClassifier] Unmapped FacilityType: ${String(_exhaustive)}`);
    }
  }
}
